<section>
  <h2>View LE partner details</h2>
  <div class="p-2 border rounded">
    <div class="row gy-2 gx-3 align-items-center m-2">
      <div *removeIfNoPermission="canEditLEPartner" class="col-12">
        <button *ngIf="isEditAllowed" class="btn btn-active" (click)="editLEPartner()">Edit LE Partner</button>
      </div>
      <div class="col-lg-4 col-md-5">First Name:</div>
      <div class="col-lg-8 col-md-7">{{ lePartner?.FirstName }}</div>
      <div class="col-lg-4 col-md-5">Middle Name:</div>
      <div class="col-lg-8 col-md-7">{{ lePartner?.MiddleName  }}</div>
      <div class="col-lg-4 col-md-5">Last Name:</div>
      <div class="col-lg-8 col-md-7">{{ lePartner?.LastName  }}</div>
      <div class="col-lg-4 col-md-5">Title:</div>
      <div class="col-lg-8 col-md-7">{{ lePartner?.Title }}</div>
      <div class="col-lg-4 col-md-5">Suffix:</div>
      <div class="col-lg-8 col-md-7">{{ lePartner?.Suffix }}</div>
      <div class="col-lg-4 col-md-5">Email Address:</div>
      <div class="col-lg-8 col-md-7">{{ !!lePartner?.ENESS_XREF_LEPartnersEmailAccounts?.length ? lePartner?.ENESS_XREF_LEPartnersEmailAccounts[0].EmailAccount : ''  }}</div>
      <div class="col-lg-4 col-md-5">Phone Number(s):</div>
      <div class="col-lg-8 col-md-7">
        <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
          <thead>
            <tr>
              <th scope="col">Phone number(s)</th>
              <th scope="col">Type</th>
              <th scope="col">Primary</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="lePartner.ENESS_XREF_LEPartnersPhoneNumbers?.length == 0"><td colspan="3">No phone numbers found.</td></tr>
            <tr *ngFor="let phone of lePartner.ENESS_XREF_LEPartnersPhoneNumbers">
              <td>{{ phone.PhoneNumber | phoneNumberFormat }}</td>
              <td>{{ phone.PhoneNumberType }} <ng-container *ngIf="!!phone.PhoneNumberOtherType">({{ phone.PhoneNumberOtherType }})</ng-container></td>
              <td>{{ phone.IsPrimary | booleanTransform }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-4 col-md-5">Badge Number:</div>
      <div class="col-lg-8 col-md-7">{{ lePartner?.Badge }}</div>
    </div>
  </div>
  <button type="button" (click)="onClose()" class="btn btn-active my-3">Close</button>
</section>

